import React, { useEffect, useState } from 'react';
import AssignmentForm from '../components/AssignmentForm';
import AssignmentList from '../components/AssignmentList';
import useAssignments from '../hooks/useAssignments';
import { BACKEND_URL } from '../config';
import fetchWithAuth from '../utils/fetchWithAuth';

const AssignmentsPage = ({ user }) => {
  // If no role, render nothing
  if (!user?.role) return null;

  const { assignments, addAssignment, refreshAssignments, setRefreshAssignments, genericSavedMsg } = useAssignments();
  const [vehicles, setVehicles] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const isConductor = user.role === "Conductor" || user.role === "conductor";

  useEffect(() => {
    fetchWithAuth(`${BACKEND_URL}/vehicles`)
      .then(res => res.json())
      .then(data => setVehicles(data));
    fetchWithAuth(`${BACKEND_URL}/drivers`)
      .then(res => res.json())
      .then(data => setDrivers(data));
  }, []);

  return (
    <div className="space-y-6">
      {genericSavedMsg && (
        <div className="bg-green-100 text-green-800 px-4 py-2 rounded">
          {genericSavedMsg}
        </div>
      )}
      {/* Only show the form if NOT conductor */}
      {!isConductor && (
        <AssignmentForm
          onSave={addAssignment}
          vehicles={vehicles}
          drivers={drivers}
          user={user}
        />
      )}
      <AssignmentList
        drivers={drivers}
        refresh={refreshAssignments}
        isConductor={isConductor}
      />
    </div>
  );
};

export default AssignmentsPage;